import axios from 'axios'
import globalConfig from '@/config/index'
import store from '@/store/store'
axios.defaults.baseURL = globalConfig.api_server

axios.interceptors.request.use(
    function(config) {
        config.headers['Content-Type'] = 'application/json'
        return config
    },
    function(error) {
        // Do something with request error
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    function(resp) {
        let data = resp.data

        if (!resp.config.headers.jsonStringOff) {
            if (typeof data == String) {
                data.response = JSON.parse(data)
            } else {
                return data
            }
        }

        if (data && (data.error == '-65' || data.response?.code == '-65')) {
            store.commit('resetState')
            return Promise.reject(data.error)
        }
        if (data && (data.response?.error || data.error)) {
            return Promise.reject(data)
        } else return data
    },
    function(error) {
        if (error.response && error.response.data.error == '-66') {
            if (store.getters['dialog/showDialogFind']) {
                store.commit('dialog/setNotificationErr', true)
                store.commit('dialog/setNotificationTitle', error.response.data.message)
                return Promise.reject(error.response.data)
            }
        }
        return Promise.reject(error)
    }
)

export default axios

export let ipinfo = axios.create({
    baseURL: 'https://ipinfo.io',
    headers: { 'content-type': 'application/json' }
})
